import React from 'react';
import { Stack } from '@mui/material';

import { FieldChange } from './FieldChange';
import { DecisionStateChanges } from '../../../types';
import { CREDIT_SUB_STAGE_OPTIONS } from '../../../../constants';

const getStageLabel = (code: number | null): string => {
  if (code === null) return '—';
  const found = CREDIT_SUB_STAGE_OPTIONS.find(opt => opt.value === code);
  return found?.label ?? String(code);
};

interface DecisionStateRenderProps {
  changes: DecisionStateChanges;
}

export const DecisionStateRender = ({ changes }: DecisionStateRenderProps) => (
  <Stack gap="0.25rem">
    {changes.decision && (
      <FieldChange label="Decision" before={changes.decision.before ?? '—'} after={changes.decision.after ?? '—'} />
    )}

    {changes.stage && (
      <FieldChange
        label="Stage"
        before={getStageLabel(changes.stage.before)}
        after={getStageLabel(changes.stage.after)}
      />
    )}

    {changes.prequal_decision && (
      <FieldChange
        label="Prequal Decision"
        before={changes.prequal_decision.before ?? '—'}
        after={changes.prequal_decision.after ?? '—'}
      />
    )}
  </Stack>
);
